import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Building2,
  Mail,
  MapPin,
  Shield, 
  Heart,
  HelpCircle,
  Globe,
  FileText,
  Twitter,
  Linkedin,
  Facebook,
  Instagram,
  BookOpen,
  ShieldAlert,
  TrendingUp,
  Coffee
} from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-900 text-white">
      {/* Footer Content */}
      <div className="py-12">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8">
            {/* Company Info */}
            <div>
              <div className="flex items-center gap-2 mb-4">
                <Building2 className="h-6 w-6 text-avn-purple-400" />
                <span className="text-xl font-bold">AVN</span>
              </div>
              <p className="text-gray-400 mb-6">
                Transforming agriculture through ethical innovation and transparency.
              </p>
              <div className="space-y-2">
                <div className="flex items-center gap-2 text-gray-400">
                  <MapPin className="h-5 w-5 text-avn-purple-400" />
                  <span>128 City Road, London, EC1V 2NX</span>
                </div>
                <div className="flex items-center gap-2 text-gray-400">
                  <Mail className="h-5 w-5 text-avn-purple-400" />
                  <a href="mailto:info@avnearth.com" className="hover:text-white">info@avnearth.com</a>
                </div>
              </div>
              
              {/* Social Media Links */}
              <div className="flex gap-4 mt-6">
                <a href="https://twitter.com/avnearth" className="text-gray-400 hover:text-white transition-colors" aria-label="Twitter">
                  <Twitter className="h-5 w-5" />
                </a>
                <a href="https://linkedin.com/company/avnearth" className="text-gray-400 hover:text-white transition-colors" aria-label="LinkedIn">
                  <Linkedin className="h-5 w-5" />
                </a>
                <a href="https://facebook.com/avnearth" className="text-gray-400 hover:text-white transition-colors" aria-label="Facebook">
                  <Facebook className="h-5 w-5" />
                </a>
                <a href="https://instagram.com/avnearth" className="text-gray-400 hover:text-white transition-colors" aria-label="Instagram">
                  <Instagram className="h-5 w-5" />
                </a>
              </div>
            </div>
            
            {/* Links */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Platform</h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/avn" className="text-gray-400 hover:text-white flex items-center gap-1">
                    <Building2 className="h-4 w-4" />
                    <span>Our Approach</span>
                  </Link>
                </li>
                <li>
                  <Link to="/market-insights" className="text-gray-400 hover:text-white flex items-center gap-1">
                    <TrendingUp className="h-4 w-4" />
                    <span>Market Insights</span>
                  </Link>
                </li>
                <li>
                  <Link to="/publications" className="text-gray-400 hover:text-white flex items-center gap-1">
                    <BookOpen className="h-4 w-4" />
                    <span>Publications</span>
                  </Link>
                </li>
                <li>
                  <Link to="/faqs" className="text-gray-400 hover:text-white flex items-center gap-1">
                    <HelpCircle className="h-4 w-4" />
                    <span>FAQs</span>
                  </Link>
                </li>
                <li>
                  <Link to="/privacy" className="text-gray-400 hover:text-white flex items-center gap-1">
                    <Shield className="h-4 w-4" />
                    <span>Privacy Policy</span>
                  </Link>
                </li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold mb-4">Our Work</h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/unity-bean" className="text-gray-400 hover:text-white flex items-center gap-1">
                    <Coffee className="h-4 w-4" />
                    <span>Unity Bean</span>
                  </Link>
                </li>
                <li>
                  <Link to="/not-on-our-plates" className="text-gray-400 hover:text-white flex items-center gap-1">
                    <ShieldAlert className="h-4 w-4" />
                    <span>#NotOnOurPlates</span>
                  </Link>
                </li>
                <li>
                  <Link to="/education" className="text-gray-400 hover:text-white flex items-center gap-1">
                    <Globe className="h-4 w-4" />
                    <span>REGEN Campus</span>
                  </Link>
                </li>
                <li>
                  <Link to="/edwards-hamlet" className="text-gray-400 hover:text-white flex items-center gap-1">
                    <Building2 className="h-4 w-4" />
                    <span>Edward's Hamlet</span>
                  </Link>
                </li>
                <li>
                  <a href="/docs/avn-whitepaper.pdf" className="text-gray-400 hover:text-white flex items-center gap-1">
                    <FileText className="h-4 w-4" />
                    <span>Whitepaper</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      {/* Copyright */}
      <div className="bg-gray-950 py-4">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-500 text-sm mb-4 md:mb-0">
              &copy; {currentYear} AVN Network. All rights reserved. Version 1.0.0
            </div>
            <div className="flex items-center gap-2 text-gray-500 text-sm">
              <Heart className="h-4 w-4 text-avn-purple-400" />
              <span>Made with love for a better food system</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;